import React from "react";
import { MapPin, Phone, Mail, Navigation } from "lucide-react";

export default function ContactSection({ contact }) {
  const c = contact || {};
  const buttonColor = c.buttonColor || "#1f3a2c";

  return (
    <section id="contact" className="py-24 md:py-32 bg-[#faf3e3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[12px] tracking-tight-wide text-[#a08862] font-semibold">
            {c.eyebrow}
          </p>
          <h2 className="font-serif-display text-4xl md:text-6xl text-[#2a2a2a] mt-4">
            {c.title}
          </h2>
          <div className="divider-line" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          {/* Map */}
          <div className="rounded-xl overflow-hidden shadow-lg bg-white min-h-[380px]">
            {c.mapEmbedUrl ? (
              <iframe
                src={c.mapEmbedUrl}
                title="Location"
                className="w-full h-full min-h-[380px] border-0"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            ) : (
              <div className="flex items-center justify-center h-full text-gray-400">
                Map embed URL not set
              </div>
            )}
          </div>

          {/* Info */}
          <div className="space-y-5">
            <InfoRow
              icon={<MapPin className="w-5 h-5 text-[#a08862]" />}
              title="Address"
              text={c.address}
            />
            <InfoRow
              icon={<Phone className="w-5 h-5 text-[#a08862]" />}
              title="Call"
              text={c.phone}
              link={`tel:${c.phone}`}
            />
            <InfoRow
              icon={<Mail className="w-5 h-5 text-[#a08862]" />}
              title="Email"
              text={c.email}
              link={`mailto:${c.email}`}
            />
            <a
              href={c.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: buttonColor }}
              className="inline-flex items-center gap-2 hover:opacity-90 text-white text-[12px] tracking-tight-wide px-8 py-4 rounded-md transition-opacity duration-300 font-semibold"
            >
              <Navigation size={16} /> GET DIRECTIONS
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoRow({ icon, title, text, link }) {
  const inner = (
    <div className="flex items-start gap-4 bg-[#f5ebd6] p-5 rounded-lg transition-transform duration-300 hover:-translate-y-0.5">
      <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shrink-0">
        {icon}
      </div>
      <div>
        <p className="text-[11px] tracking-tight-wide text-[#8a7a5c] font-semibold mb-1">
          {title.toUpperCase()}
        </p>
        <p className="text-[15px] text-[#2a2a2a]">{text}</p>
      </div>
    </div>
  );
  return link ? <a href={link} className="block">{inner}</a> : inner;
}
